/*----------------------------------------*\
  SCROLL
\*----------------------------------------*/

let lastPosition;

/**
 * Prevent window from scrolling when user reach the scroll end
 * of a child element overflow
 */
function preventWindowScroll(e) {
  if (!e) {
    return;
  }

  const target = e.currentTarget || e.originalEvent.currentTarget;
  const height = target.getBoundingClientRect().height;
  const scrollHeight = target.scrollHeight;

  if (
    (target.scrollTop === 0 && e.deltaY < 0) ||
    (target.scrollTop === Math.floor(scrollHeight - height) && e.deltaY > 0)
  ) {
    e.preventDefault();
  }
}

/**
 * Save position for later calculation of touch direction
 * @param  {Event} e
 */
function prepareToPreventWindowScroll(e) {
  if (e && e.touches && e.touches[0]) {
    lastPosition = e.touches[0].clientY;
  }
}

/**
 * Prevent window from scrolling when user reach the of an element
 * scroll on touch devices
 * @param  {Event} e
 */
function preventWindowScrollTouch(e) {
  let delta;

  if (e && e.touches && e.touches[0]) {
    const currentPosition = e.touches[0].clientY;

    if (currentPosition > lastPosition) {
      delta = -1;
    } else if (currentPosition < lastPosition) {
      delta = 1;
    }

    lastPosition = currentPosition;
  } else {
    delta = e.deltaY;
  }

  const target = e.currentTarget;
  const height = target.getBoundingClientRect().height;
  const scrollHeight = target.scrollHeight;
  const scrollTop = target.scrollTop;

  if (
    (scrollTop === 0 && delta < 0) ||
    (scrollTop === Math.floor(scrollHeight - height) && delta > 0)
  ) {
    e.preventDefault();
  }
}

/**
 * Prevent window scroll with both wheel and touch when the given element scroll ends is reached
 * @param  {Element} el The scollable element
 */
export function restrictScroll(el) {
  el.addEventListener('wheel', preventWindowScroll);
  el.addEventListener('touchstart', prepareToPreventWindowScroll);
  el.addEventListener('touchmove', preventWindowScrollTouch);
}

/**
 * Remove window scroll restrictions
 * @param  {Element} el The scollable element
 */
export function unleashScroll(el) {
  el.removeEventListener('wheel', preventWindowScroll);
  el.removeEventListener('touchstart', prepareToPreventWindowScroll);
  el.removeEventListener('touchmove', preventWindowScrollTouch);
}
